import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Users, Layers, Zap, Shield, Target, Rocket } from 'lucide-react';

export default function PricingTeam() {
  return (
    <SubpageTemplate 
      title="Team Plan"
      subtitle="The Collaborative Crew"
      description="Scale your agency or startup with shared builds, team-wide design systems, and priority synthesis queues."
      icon={Users}
      features={[
        {
          title: "Shared Workbench",
          description: "Multiple builders operating on the same project state with real-time sync.",
          icon: Layers
        },
        {
          title: "Priority Queue",
          description: "Your technical builds are processed on our high-performance inference clusters.",
          icon: Zap
        },
        {
          title: "Team Assets",
          description: "Shared distribution kits and branded deployment templates.",
          icon: Target
        }
      ]}
    />
  );
}
